import { motion } from 'motion/react';
import { twMerge } from 'tailwind-merge';

type ResourceUploadProgressProps = {
  progress?: number;
};

export default function ResourceUploadProgress({
  progress = 0,
}: ResourceUploadProgressProps) {
  const visibility = !!progress && progress !== 100 ? '' : 'hidden';

  return (
    <motion.div
      className={twMerge(
        'bg-secondary h-1.5 absolute bottom-0 left-0',
        progress < 100 ? 'rounded-r-lg' : 'rounded-br-lg',
        'rounded-bl-lg',
        visibility,
      )}
      animate={{
        width: `${progress}%`,
      }}
    />
  );
}
